export const POKEMON = 'https://pokeapi.co/api/v2/pokemon'
